import CategoriesListModal from './categories-list-modal';
export default CategoriesListModal;